/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Estimate } from './Estimate';
import {
    EstimateFromJSON,
    EstimateFromJSONTyped,
    EstimateToJSON,
    EstimateToJSONTyped,
} from './Estimate';

/**
 * Paginated list of estimates.
 * @export
 * @interface EstimateListResponse
 */
export interface EstimateListResponse {
    /**
     * 
     * @type {Array<Estimate>}
     * @memberof EstimateListResponse
     */
    estimates: Array<Estimate>;
    /**
     * 
     * @type {number}
     * @memberof EstimateListResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateListResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateListResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the EstimateListResponse interface.
 */
export function instanceOfEstimateListResponse(value: object): value is EstimateListResponse {
    if (!('estimates' in value) || value['estimates'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function EstimateListResponseFromJSON(json: any): EstimateListResponse {
    return EstimateListResponseFromJSONTyped(json, false);
}

export function EstimateListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'estimates': ((json['estimates'] as Array<any>).map(EstimateFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
    };
}

export function EstimateListResponseToJSON(json: any): EstimateListResponse {
    return EstimateListResponseToJSONTyped(json, false);
}

export function EstimateListResponseToJSONTyped(value?: EstimateListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'estimates': ((value['estimates'] as Array<any>).map(EstimateToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
    };
}

